export default __webpack_public_path__ + "static/media/partners.32b170f3.svg";